module.exports = __webpack_public_path__ + "static/gothic-a1-v8-latin-700-81ace063e4315eda2c0893a6810f5a27.woff";